import { faThumbTack } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack } from "@mui/material";
import { MprcLink, MprcRequestIndicator } from "components";
import { IconLock } from "components/icons/IconLock";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { useCoreApi } from "providers/CoreApiProvider";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

///
export const IconChannelPinned = () => {
    const [posting, setPosting] = useState<boolean>(false);
    const { t } = useTranslation("knowledge");
    const api = useCoreApi();

    const {
        pub: {
            publicationId,
            channelPinnedOn,
            isPrivate
        },
        onFeedReload
    } = useCardContext();

    ///
    const handleChannelPinned = () => {
        setPosting(true);
        api.v1.knowledgeFeed.publicationToogleChannelPinned({ publicationId })
            .then(() => onFeedReload && onFeedReload())
            .catch((error) => MprcRequestSnackbarErrorReport(error))
            .finally(() => setPosting(false));
    };

    return (channelPinnedOn || isPrivate) && (
        <>
            <MprcRequestIndicator type="post" visible={posting} />
            <div style={{ height: 24 }}>
                <Stack direction="row" spacing={1}>
                    {isPrivate &&
                        <span title={t("Feed.Card.Common.PrivateTooltip")}>
                            <IconLock locked lockedColor="muted" />
                        </span>
                    }
                    {
                        channelPinnedOn &&
                        <MprcLink onClick={handleChannelPinned} title={t("Feed.Card.Options.ChannelUnpinnedAction")}>
                            <FontAwesomeIcon icon={faThumbTack} fixedWidth />
                        </MprcLink>
                    }
                </Stack>
            </div>
        </>
    );
};
